import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { formDateFilter, formTimeFilter } from "@monorepo/utils/src/api/convertFiltersToApi";

export const convertFiltersCustomToApi = (
  resultFilters: ITableFiltersObject & { fieldFilters: { createDateFrom?: string; createDateTo?: string } }
): void => {
  formDateFilter(resultFilters, "createDate");
  formTimeFilter(resultFilters, "time");
};
